module.exports = __webpack_public_path__ + "static/media/recharge-successful.1061f97b.svg";